var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Share'),expression:"'Share'"}],staticClass:"clickable",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"share"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }